export default __webpack_public_path__ + "static/assets/med_pill_rectangle_flat_L1_solid_x_01_f.17561eb2.png";